import { useCallback, useEffect, useState } from 'react'

import { getAdEligibilityForTransaction } from '@marketplace-web/ads/ads-data'

const useIsTransactionEligibleForAd = (transactionId?: number) => {
  const [isEligibleForAd, setIsEligibleForAd] = useState(false)

  const fetchAdEligibilityForTransaction = useCallback(async () => {
    if (!transactionId) return

    const response = await getAdEligibilityForTransaction(transactionId)

    if ('errors' in response || !response.show_offer) {
      setIsEligibleForAd(false)

      return
    }

    setIsEligibleForAd(response.show_offer)
  }, [transactionId])

  useEffect(() => {
    fetchAdEligibilityForTransaction()
  }, [fetchAdEligibilityForTransaction])

  return isEligibleForAd
}

export default useIsTransactionEligibleForAd
